import React from "react";

class Loading extends React.Component {
  constructor() {
    super();
  }

  render() {
    if (this.props.show) {
      return (
        <div className="popup-cent loading">
          <div className="overlay">
            <div className="icon-loading"><i className="fa fa-spinner fa-spin"></i></div>
          </div>
        </div>
      );
    } else return <div></div>;
  }
}
export default Loading;
